"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goToPrevMenu = exports.changeMobileMenuName = exports.changeMemuProps = exports.changeMenuFromName = exports.updateMenu = void 0;
const actionType_1 = require("./actionType");
const updateMenu = (depths, menu, id, props, isHistory) => {
    return {
        type: actionType_1.SET_MENU,
        depths,
        menu,
        id,
        props,
        isHistory,
    };
};
exports.updateMenu = updateMenu;
const changeMenuFromName = (name, isMain = false) => {
    return {
        type: actionType_1.CHANGE_MENU_FROM_NAME,
        name,
        isMain,
    };
};
exports.changeMenuFromName = changeMenuFromName;
const changeMemuProps = (props) => {
    return {
        type: actionType_1.CHANGE_MENU_PROPS,
        props,
    };
};
exports.changeMemuProps = changeMemuProps;
const changeMobileMenuName = (name) => {
    return {
        type: actionType_1.CHANGE_MOBIL_MENU_NAME,
        name,
    };
};
exports.changeMobileMenuName = changeMobileMenuName;
const goToPrevMenu = () => {
    return {
        type: actionType_1.GO_TO_PREV_MENU,
    };
};
exports.goToPrevMenu = goToPrevMenu;
